// extracted by mini-css-extract-plugin
export default {"result_buttons_container":"ErrorButtons_result_buttons_container__Wq6gF"};